// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RichEditor_wrapper__1ENyb"};